import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { resetErrorMessage } from 'actions/internal';
import { loadGroupCohortsByOrganizationTypeFilters, loadGroupCohortsByOrganizationType } from 'actions/partner';
import { loadGroupCohortsCSVReport } from 'actions/groupCohortsOrganizationType';
import { isEqual, get, toLower } from 'lodash';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import GroupCohortsContainer from './reports/byorganizationtype/GroupCohortsContainer';
import GroupCohortsFilterContainer from './reports/byorganizationtype/GroupCohortsFilterContainer';
import GroupCohortsSubNav from 'components/nav/GroupCohortsSubNav';

class GroupCohortsReportOrganizationTypePage extends React.Component {
  static propTypes = {
    isAuthChecked: PropTypes.bool.isRequired,
    loadGroupCohortsByOrganizationType: PropTypes.func.isRequired,
    loadGroupCohortsByOrganizationTypeFilters: PropTypes.func.isRequired,
    loadGroupCohortsCSVReport: PropTypes.func.isRequired,
    resetErrorMessage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadGroupCohortsByOrganizationTypeFilters({source: 'init'});
    this.props.loadGroupCohortsByOrganizationType(this.props.history.location.search, {source: 'init'});
    this.props.loadGroupCohortsCSVReport(0);
  }

  componentDidUpdate(prevProps) {
    const isFromNavBar = get(this.props.location, 'state.from') === 'navbar' && get(prevProps.location, 'state.from') !== 'navbar';
    if (isFromNavBar || (!isEqual(prevProps.location, this.props.location) && toLower(this.props.history.action) === 'pop')) {
      this.props.loadGroupCohortsByOrganizationType(this.props.history.location.search, {source: 'init'});
    }
  }

  render() {
    if (!this.props.isAuthChecked) return null;
    return (
      <DocumentTitle title={this.props.t('reports.groupCohortPageTitle')}>
        <div>
          <TopNavBar />
          <SubNavBar />
          <GroupCohortsSubNav />
          <div className="row">
            <div className="column">
              <GroupCohortsFilterContainer />
              <GroupCohortsContainer />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthChecked: state.auth.isAuthChecked,
  }
}

export default connect(mapStateToProps, {
  resetErrorMessage,
  loadGroupCohortsByOrganizationTypeFilters,
  loadGroupCohortsByOrganizationType,
  loadGroupCohortsCSVReport,
})(withTranslation()(GroupCohortsReportOrganizationTypePage));
